import { call, put, takeEvery } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  getCurrentSubscription,
  getAvailablePlans,
  upgradeSubscription,
  SubscriptionUpgradeRequest,
} from "@/services/subscriptionService";
import { toApiError } from "@/lib/errorHelpers";
import {
  fetchCurrentSubscriptionRequest,
  fetchCurrentSubscriptionSuccess,
  fetchCurrentSubscriptionFailure,
  fetchAvailablePlansRequest,
  fetchAvailablePlansSuccess,
  fetchAvailablePlansFailure,
  upgradeSubscriptionRequest,
  upgradeSubscriptionSuccess,
  upgradeSubscriptionFailure,
} from "@/store/slices/subscription.slice";

function* fetchCurrentSubscriptionSaga(): Generator<any, void, any> {
  try {
    const response: any = yield call(getCurrentSubscription);
    yield put(fetchCurrentSubscriptionSuccess(response.data || response));
  } catch (error: any) {
    yield put(
      fetchCurrentSubscriptionFailure(
        toApiError(error)?.message || "Failed to fetch current subscription",
      ),
    );
  }
}

function* fetchAvailablePlansSaga(): Generator<any, void, any> {
  try {
    const response: any = yield call(getAvailablePlans);
    yield put(fetchAvailablePlansSuccess(response.data || response));
  } catch (error: any) {
    yield put(
      fetchAvailablePlansFailure(
        toApiError(error)?.message || "Failed to fetch available plans",
      ),
    );
  }
}

function* upgradeSubscriptionSaga(
  action: PayloadAction<SubscriptionUpgradeRequest>,
): Generator<any, void, any> {
  try {
    const { planId, billingCycle } = action.payload;

    // Use the upgrade function - backend determines upgrade vs downgrade
    const response: any = yield call(upgradeSubscription, {
      planId,
      billingCycle,
    });

    yield put(upgradeSubscriptionSuccess(response.data || response));

    // Refresh current subscription after successful change
    yield put(fetchCurrentSubscriptionRequest());
  } catch (error: any) {
    yield put(
      upgradeSubscriptionFailure(
        toApiError(error)?.message || "Failed to process subscription change",
      ),
    );
  }
}

export function* subscriptionSaga(): Generator<any, void, any> {
  yield takeEvery(
    fetchCurrentSubscriptionRequest.type,
    fetchCurrentSubscriptionSaga,
  );
  yield takeEvery(fetchAvailablePlansRequest.type, fetchAvailablePlansSaga);
  yield takeEvery(upgradeSubscriptionRequest.type, upgradeSubscriptionSaga);
}
